import { createAction } from '@ngrx/store';

/** User initiated logout – redirects to the external logout endpoint. */
export const logout = createAction('[Auth] Logout');

/**
 * Dispatched by the HTTP interceptor when a 401 is received after the session
 * has already been successfully bootstrapped (i.e. runtime session expiry).
 */
export const sessionExpired = createAction('[Auth] Session Expired');

/**
 * Dispatched when the user confirms the session-expired modal, triggering the
 * redirect to the external login page.
 */
export const sessionExpiredConfirmed = createAction('[Auth] Session Expired Confirmed');
